import React from 'react'
import TopFv from "./top-components/TopFv"
import News from "./top-components/News"
import FindCourses from "./top-components/FindCourses"
import Access from "./top-components/Access"
import Contact from "./top-components/Contact"

import { createGlobalStyle } from "styled-components"
import media from "styled-media-query"

const Top = ({setSchool}) => {

   return (
      <>
         <TopGlobalStyles />
         <TopFv/>
         <News/>
         <FindCourses setSchool={setSchool} />
         <Access />
         <Contact/>
      </>
   )
}

const TopGlobalStyles = createGlobalStyle`
      .title-box {
      position: relative;
      width: 100%;
      height: 84px;
      background-color: #FF3D01;
      ${media.lessThan("600px")`
         height: 60px;
      `}
      h2 {
         color: #fff;
         font-size: 2.8rem;
         text-align: center;
         line-height: 84px;
         ${media.lessThan("600px")`
            line-height: 60px;
            font-size: 2.2rem;
         `}
      }
      .deco {
         position: absolute;
         width: 20px;
         height: 20px;
         z-index: 10;
         border-right: 15px solid transparent;
         border-bottom: 15px solid #fff;
         border-left: 15px solid transparent; 
         bottom: 0;
         left: 50%;
         transform: translate(-50%);
      }
   }
`


export default Top